export default __webpack_public_path__ + "static/media/sphinx-insect-shape.d0965f86.svg";